import type { PricingIndex } from '@/api/services/settings/pricing-indices.service';
import type { Company, Plant, User } from '@/interfaces';

export namespace FormUtils {
  export const getUsersOptions = (users: User[]) =>
    users.map((user) => ({ id: user.id, value: user.name, label: user.name }));

  export const getPlantsOptions = (plants: Plant[]) =>
    plants.map((plant) => ({ id: plant.id, value: plant.alias, label: plant.alias }));

  export const getPricingIndicesOptions = (pricingIndices: PricingIndex[]) =>
    pricingIndices.map((pi) => ({ id: pi.id, value: pi.name, label: pi.name }));

  export const getInitialStateCups = (cups: Plant) => ({
    identifier: cups.identifier,
    alias: cups.alias,
    users: getUsersOptions(cups.users),
    pricingIndexId: cups.pricingIndexId,
  });

  export const getInitialStateUser = (user: User) => ({
    name: user.name,
    email: user.email,
    role: user.role,
    plants: getPlantsOptions(user.plants),
  });

  export const getCompaniesOptions = (companies: Company[]) =>
    companies.map((company) => ({ id: company.id, value: company.name, label: company.name }));
}
